const DOTS = {
  BUTTON: 'dots-button',
  WRAPPER: 'dots-wrapper',
};

const FUN_FACT = {
  WRAPPER: 'fun-fact',
  LINK: 'fun-fact-link',
};

const HEADER = {
  ACCOUNT: 'header-account',
  HEADER_WRAPPER: 'header-wrapper',
  HELP: 'header-help',
  LOGIN: 'header-login',
  MY_EVERLY: 'header-my-everly',
  REGISTER_A_KIT: 'header-register-a-kit',
  REGISTER_YOUR_KIT: 'header-register-your-kit',
  SHOP_TESTS: 'header-shop-tests',
  THE_SCIENCE: 'header-the-science',
  LOGOUT: 'header-logout',
};

const INTRO = {
  WRAPPER: 'intro',
};

const MODAL = {
  CLOSE_BUTTON: 'modal-close-button',
  CONTENT: 'modal-content',
};

const POPOVER = {
  CONTENT: 'popover-content',
};

const PRODUCT_CARD = {
  MEASURES: 'measures',
  MODAL_DESCRIPTION: 'modal-description',
  MODAL_TITLE: 'modal-title',
  WRAPPER: 'product-card-wrapper',
};

const MEMBER_REDEMPTION_MODAL = {
  WRAPPER: 'member-redemption-modal-wrapper',
};

const MEMBERSHIP_CARD = {
  WRAPPER: 'membership-card-wrapper',
  PRICE: 'membership-card-price',
  JOIN_BUTTON: 'membership-join-button',
  CURRENT_MEMBER: 'membership-current-member-link',
  LOGIN_NOTE: 'membership-login-note',
  INTRO_SECTION: 'membership-intro-section',
  WELCOME_SECTION: 'membership-welcome-section',
  BENEFITS_SECTION: 'membership-benefits-section',
  SELECT_INPUT: 'membership-select-input',
  SEE_ALL_TESTS: 'membership-see-all-tests-button',
  CREDIT_INFO: 'membership-credit-info',
  ORDER_TEST: 'sti-order-first-test',
  ORDER_TEST_MODAL: 'membership-order-test-button',
  CANCEL_NOTE: 'membership-cancel-note',
  DISCLAIMER: 'membership-disclaimer-policy',
};

const TEST_RECOMMENDATION = {
  SELECT_INPUT: 'membership-test-recommendation-select-input',
};

const QUIZ = {
  EXIT_ICON: 'exit-icon',
  BACK_ICON: 'back-icon',
};

const BUTTON = {
  BROWSE_ALL: 'browse-all-btn',
};

const CHECKOUT = {
  BILLING_ADDRESS_RADIO_SAME: 'billing-radio-same',
  BILLING_ADDRESS_RADIO_DIFFERENT: 'billing-radio-different',
  BILLING_ADDRESS_ID: 'billing-address',
  BILLING_ADDRESS_FORM: 'billing-address-form',
  DIFFERENT_BILLING_ADDRESS_ID: 'different-billing-address',
  CARD_NUMBER_INPUT: 'card-number-checkout-input',
  EXPIRATION_DATE_INPUT: 'expiration-date-checkout-input',
  CVC_INPUT: 'cvc-checkout-input',
  OPT_IN_CHECKBOX: 'opt-in-checkbox',
  NY_DISCLAIMER_CHECKBOX: 'ny-disclaimer-checkbox',
  SHIPPING_ADDRESS_FORM: 'shipping-address-form',
  PLACE_ORDER_BUTTON: 'place-order-button',
  ORDER_SUMMARY: 'order-summary',
  ORDER_TOTALS: 'order-totals',
  SUB_TOTAL_LABEL: 'sub-total-label',
  SUB_TOTAL: 'sub-total',
  SHIPPING: 'shipping',
  DISCOUNT_TOTAL: 'discount-total',
  GRAND_TOTAL: 'grand-total',
  CHECKOUT_PAYMENT_INFORMATION: 'checkout-payment-information',
  EMAIL_CHECKOUT_INPUT: 'email-checkout-input',
  FIRST_NAME_CHECKOUT_INPUT: 'first-name-checkout-input',
  LAST_NAME_CHECKOUT_INPUT: 'last-name-checkout-input',
  ADDRESS_ONE_CHECKOUT_INPUT: 'address-one-checkout-input',
  ADDRESS_TWO_CHECKOUT_INPUT: 'address-two-checkout-input',
  STATE_CHECKOUT_INPUT: 'state-checkout-input',
  CITY_CHECKOUT_INPUT: 'city-checkout-input',
  ZIP_CODE_CHECKOUT_INPUT: 'zip-code-checkout-input',
  PHONE_NUMBER_CHECKOUT_INPUT: 'phone-number-checkout-input',
  PROMO_BUTTON: 'promo-button',
  GIFT_CARD_BUTTON: 'gift-card-button',
  LINE_ITEM: 'order-line-item',
  LINE_ITEM_NAME: 'line-item-name',
  LINE_ITEM_QUANTITY: 'line-item-quantity',
  LINE_ITEM_ORIGINAL_AMOUNT: 'line-item-original-amount',
  LINE_ITEM_TOTAL: 'line-item-total',
  DISCOUNT_APPLIED_LABEL: 'discount-applied-label',
  GIFT_CARD_APPLIED_LABEL: 'gift-card-applied-label',
  DISCOUNT_APPLIED: 'discount-applied',
  GIFT_CARD_APPLIED: 'gift-card-applied',
  STRIPE_EXPRESS_PAY: 'stripe-express-pay',
  LOADING_ANIMATION: 'loading-animation',
  PSC_RESULTS_CONTAINER_WITH_RESULTS: 'psc-results-container-with-results',
  LOCATION_NUMBER: 'location-number',
  LOCATION_NAME: 'location-name',
  LOCATION_DISTANCE: 'location-distance',
  LOCATION_ADDRESS: 'location-address',
  LOCATION_CITY_STATE_ZIP: 'location-city-state-zip',
  LOCATION_HOURS: 'location-hours',
  PSC_RESULTS_CONTAINER_EMPTY_STATE: 'psc-results-container-empty-state',
  SEARCH_BY_ZIPCODE_INPUT: 'search-by-zipcode-input',
  SEARCH_BY_ZIPCODE_BUTTON: 'search-by-zipcode-button',
  PSC_LOCATION_RESULTS: 'psc-location-results',
  SHIPPING_DISCLAIMER: 'shipping-disclaimer',
  PAY_PAL_PLACEHOLDER: 'pay-pal-placeholder',
  LINE_ITEMS_PLACEHOLDER: 'line-items-placeholder',
  DISCLOSURE_TEXT: 'disclosure-text',
  AGE_RESTRICTION_MODAL: 'age-restriction-modal',
  AGE_RESTRICTION_HEAD: 'age-restriction-head',
  AGE_RESTRICTION_BODY: 'age-restriction-body',
  HOW_DID_YOU_HEAR: 'how-did-you-hear',
  SMS_OPT_IN_CHECKBOX: 'sms-opt-in-checkbox',
  SMS_LEGAL_TEXT: 'sms-legal-text',
};

const TOAST_NOTIFICATION = {
  WRAPPER: 'notification-wrapper',
  ERROR_NOTIFICATION: 'notification-error',
  INFO_NOTIFICATION: 'notification-info',
  ICON: 'notification-icon',
  SHOW_DETAILS_BUTTON: 'notification-show-details',
  DETAILS: 'notification-details',
  CLOSE_NOTIFICATION: 'notification-close-button',
  TOOLTIP: 'notification-tooltip',
};

const MEMBERSHIP_INTAKE = {
  INDEX: {
    CONTAINER: 'mi-container',
    PAGE: 'mi-page',
  },
  SIGN_UP: {
    CONTAINER: 'mi-sign-up-container',
    FIRST_NAME: 'mi-sign-up-first-name',
    LAST_NAME: 'mi-sign-up-last-name',
    EMAIL: 'mi-sign-up-email',
    TERMS: 'mi-sign-up-terms',
    ALREADY_MEMBER: 'mi-sign-up-already-member',
    NEXT: 'mi-sign-up-next',
  },
  PAYMENT_INFO: {
    CONTAINER: 'mi-payment-container',
    STRIPE_EXPRESS_PAY: 'mi-stripe-express-pay',
    PLACE_ORDER_BUTTON: 'mi-place-order-button',
    CHECKOUT_CONTAINER: 'mi-checkout-container',
    MEMBERSHIP_FEE: 'mi-payment-membership-fee',
    MEMBERSHIP_PERKS: 'mi-payment-membership-perks',
    PAYPAL_PAY: 'mi-payment-paypal-pay',
    APPLE_PAY: 'mi-payment-apple-pay',
    ACCEPTED_CARDS: 'mi-payment-accepted-cards',
    CARD_NUMBER: 'mi-payment-card-number',
    CARD_EXPIRATION: 'mi-payment-card-expiration',
    CARD_CVC: 'mi-payment-card-cvc',
    OPT_IN_CHECKBOX: 'mi-payment-wants-marketing',
    PLACE_ORDER: 'mi-payment-place-order',
  },
  HEALTH_PROFILE: {
    CONTAINER: 'mi-health-profile-container',
  },
  CONFIRMATION: {
    CONTAINER: 'mi-confirmation-container',
    AVATAR_SELECTION: 'mi-confirmation-avatar-selection',
    EXPLORE_TESTS: 'mi-confirmation-explore-tests',
    HEALTH_PROFILE: 'mi-confirmation-health-profile',
    NOTIFICATION: 'mi-confirmation-notification',
  },
  CONSUMER_CONFIRMATION: {
    CONTAINER: 'mi-consumer-confirmation',
    DATE_OF_BIRTH: 'mi-consumer-confirmation-date-of-birth',
    TERMS: 'mi-consumer-confirmation-terms',
    PRODUCT_CONSENT: 'mi-consumer-confirmation-product-consent',
  },
  TEST_RECOMMENDATION: {
    CONTAINER: 'mi-test-recommendation-container',
  },
};

const FEATURED_TESTS = {
  CONTAINER: 'm-featured-tests-container',
  SECTION: 'm-featured-tests-section',
  SLIDE: 'm-featured-test-slide',
};

const PDP = {
  HERO_SLIDER: 'hero-slider',
  HERO_SWIPER: 'hero-swiper',
};

const PRIVACY_POLICY = {
  CONTAINER: 'privacy-policy-container',
  SECTION: 'privacy-policy-section',
};

const MEMBERSHIP_TEST_PLAN = {
  DESKTOP_NAV: '',
  MOBILE_NAV: '',
  QUEUE: '',
};

export {
  BUTTON,
  CHECKOUT,
  DOTS,
  FEATURED_TESTS,
  FUN_FACT,
  HEADER,
  INTRO,
  MEMBER_REDEMPTION_MODAL,
  MEMBERSHIP_CARD,
  MEMBERSHIP_INTAKE,
  MODAL,
  PDP,
  POPOVER,
  PRIVACY_POLICY,
  MEMBERSHIP_TEST_PLAN,
  PRODUCT_CARD,
  QUIZ,
  TEST_RECOMMENDATION,
  TOAST_NOTIFICATION,
};
